import useHomeType from 'hooks/useHomeType'

/**
 * Whether the Rostering settings pages should be locked behind the paywall.
 *
 * The test is the site's entitlement — `features.rota.granted` — not
 * `features.rota.enabled` (which `hasRota` reads, and which says whether a site
 * that HAS the add-on has switched it on). A site without the add-on granted
 * has no business seeing any of these settings.
 *
 * `SettingsPaywall` covers the page body. Use this hook directly only for
 * controls that live outside it — a save button in the page header or a fixed
 * footer — which would otherwise stay on screen next to the locked message.
 */
const useRosteringPaywall = () => {
  const { features } = useHomeType()

  return { isLocked: features?.rota?.granted !== true }
}

export default useRosteringPaywall
